module.exports = __webpack_public_path__ + "img/svg_add.789b188d.svg";